import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import BreadCrumbs from 'components/commons/BreadCrumbs';
import GameBlock from 'components/game/GameBlock';
import TradeDetail from 'components/game/TradeDetail';
import ProductDetail from 'components/game/ProductDetail';
import CommentBoard from 'components/game/CommentBoard';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators'
import CupoyRouter from "components/commons/router/CupoyRouter";
import GLOBAL from 'nonnglobal';

/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const TABS = {
  NOTICE: 'notice',
  MESSAGE: 'message',
};
const isBoolean = val => typeof val === 'boolean';
/**
|--------------------------------------------------
| Styled
|--------------------------------------------------
*/
const Container = styled.div`
  display: grid;
  grid-template-columns: 244px 1fr;
  margin-top: ${GlobalStyle.ViewSpace}px;
  grid-gap: ${GlobalStyle.ViewSpace}px;
`

const Main = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${GlobalStyle.ViewSpace}px;
`
const NavContainer = GlobalStyle.BasicBlock.extend`
`;
const NavList = styled.ul`
    display: grid;
    grid-template-columns: ${props => `repeat(${props.gridNum}, auto) 1fr`};
    grid-auto-flow: column;
    justify-content: start;
    align-items: center;
    margin: 0;
    background-color: #FFF;
`;
const NavItemTouch = styled.div`
    height: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 9px;
    color: inherit;
`;
const NavItem = styled.li`
    margin-left: 30px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
    > div {
    border-bottom: 2px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
    }

    ${NavItemTouch} {
        color: ${props => props.isActive ? Colors.MAIN_COLOR : '#4A4A4A'};
        font-weight: ${props => props.bold && props.isActive ? 'bold':''}
    }

    &:first-child {
    margin-left: ${props => props.marginLeft? props.marginLeft:30}px;
    }
`;

class SaleDetailView extends PureComponent {

  constructor(props) {
    super(props);

    this.changeTabToNotice = this.changeTab.bind(this, TABS.NOTICE);
    this.changeTabToMessage = this.changeTab.bind(this, TABS.MESSAGE);

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;
    const { gameid, serverid, viprovid } = params;
    const { sellerMap } = props;
    const seller = sellerMap[`${viprovid},${gameid},${serverid}`] || {};

    this.state = {
      gameid,
      serverid,
      viprovid,
      character: '',
      descriptoin: '',
      dollar: '',
      maxDollar: seller ? seller.maxDollar : '',
      minDollar: seller ? seller.minDollar : '',
      tradetime: '',
      error_dollarInput: false,
      tab: TABS.NOTICE,
      isOpen: GLOBAL.getVProviderIsOpen(seller),
    };
  }

  componentDidMount() {

    const { haslogin } = this.props;

    window.scrollTo({ top: 0 });

    haslogin && this.init();
  }

  componentDidUpdate(nextProps) {

    const { haslogin } = this.props;

    if((nextProps.haslogin !== haslogin) && haslogin)
      this.init();
  }

  init = () => {

    const {
      gameid, 
      serverid,
      viprovid,
    } = this.state;

    const { sellerMap } = this.props;
    const seller = sellerMap[`${viprovid},${gameid},${serverid}`];
        
    if(!seller)
        this.props.vitemActions.initOrder({ gameid, gameserverid: serverid, viprovid });

    if(Object.keys(this.props.gameListMap).length === 0)
        this.props.gameActions.listGames();
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    const {
      viprovid,
      gameid,
      serverid,
      maxDollar,
      minDollar,
      isOpen,
    } = prevState;

    const _seller = nextProps.sellerMap[`${viprovid},${gameid},${serverid}`];

    if(_seller && (!maxDollar || !minDollar || !isBoolean(isOpen))) {

      const {
        inventory,
        vitemdollar,
        ntdollar,
      } = _seller;
      
      const maxDollar = Math.floor(inventory / (vitemdollar / ntdollar));
      const minDollar = Math.ceil(100 / ntdollar) * ntdollar;

      return {
        maxDollar,
        minDollar,
        isOpen: GLOBAL.getVProviderIsOpen(_seller),
      };
    }
    
    return null;
  }

  changeTab = tab => {
    this.setState({ tab });
  }

  handleCharacterInput = event => {
    const value = event.target.value;
    this.setState({ character: value });
  }

  handleDescriptoinInput = event => {
    const value = event.target.value;
    this.setState({ descriptoin: value });
  }

  handleTradetimeInput = event => {
    const value = event.target.value;
    this.setState({ tradetime: value });
  }
  

  addTradeMoney = () => {
    const { minDollar, dollar } = this.state;

    if(dollar < minDollar) {
      this.setState({ dollar: minDollar });
      return;
    }

    this.setState(prevState => ({ dollar: +prevState.dollar + 1 }));
  }

  minusTradeMoney = () => {
    const { minDollar, dollar } = this.state;

    if(dollar < minDollar) {
      this.setState({ dollar: minDollar });
      return;
    }

    if(((dollar - 1) < 0 || (dollar - 1) < minDollar)) 
      return;
    this.setState(prevState => ({ dollar: +prevState.dollar - 1 }));
  }

  handleDollarChange = event => {
    const value = event.target.value;
    const regexp = /^[0-9]*$/;

    if(!regexp.test(value))
      return;
      
    this.setState({ dollar: value });
  }

  submit = () => {

      const {
          gameid, 
          serverid: gameserverid,
          viprovid,
      } = this.state;

      const {
          ntdollar,
          vitemdollar,
          gamename,
          commission,
          nickname,
      } = this.props.sellerMap[`${viprovid},${gameid},${gameserverid}`];

      const {
          maxDollar,
          minDollar,            
          character,
          tradetime,
          descriptoin,
          dollar,
      } = this.state;

      const {
          buildVItemCartOrder,
      } = this.props.vitemActions;
      
      const proportion = vitemdollar / ntdollar;
      const commissionPrice = commission ?
          Math.round((this.state.dollar / 100) * commission)
          : 0;
      let totalPrice = (dollar * proportion);

      if(commission){
          totalPrice -= (commissionPrice * proportion);
          totalPrice = Math.round(totalPrice);
      }

      const txtcontent = '<b>伺服器內角色</b> : '+character+'<br /><b>交易時間</b> : '+tradetime+'<br /><b>交易過程詳述</b> : '+descriptoin;

      if(dollar >= minDollar && dollar <= maxDollar && dollar <= 10000 && dollar >= 100 && (dollar % ntdollar === 0)){
        this.setState({
          dollar,
          error_dollarInput: false,
          isPurchasePage: true,
        });
        if(!character){
          this.props.webActions.openAlertDialog({
            title: '錯誤訊息',
            description : '請輸入伺服器內角色',
            closeName: '關閉',
          });
          return;
        }

        // 需要建立訂單 執行buildVItemCartOrder
        buildVItemCartOrder({
          amount: dollar, // 購買金額（NT）
          vitemamount: totalPrice, // 購買金額（VITEM）
          gameid,
          gameserverid,
          viprovid,
          gamename,
          txtcontent,
          viprovname: nickname,
        }).then(() => {
          this.props.webActions.cupoyStateGo(CupoyRouter.STATES.PRODUCT_CHECKOUT);
        }, error => {
          let errorMsg = '發生無法預期的錯誤';
          let errorDescription = '';

          if(error && error.code) {
            switch(error.code) {
              case 'error.privilege.noLogin':
                return;
              default:
                errorMsg = error.message;
                break;
            }
          }

          this.props.webActions.openAlertDialog({
            title: errorMsg,
            description: errorDescription,
          });
        })
      } else {
        this.setState({
          error_dollarInput: true,
        });
        this.props.webActions.openAlertDialog({
          title: '錯誤訊息',
          description : minDollar > maxDollar ? 
            '庫存沒有達到最低購買金額限制' : '購買金額只能大於' + minDollar + '小於' + maxDollar + '且為' + ntdollar +'的倍數',
          closeName: '關閉',
        });
      };
  }
  
  render() {
    
    const {
      haslogin,
    } = this.props;    

    return (
      <GlobalStyle.SubContainer>
        {
          haslogin ?
          this.renderLogin()
          :
          this.renderNoLogin()
        }
      </GlobalStyle.SubContainer>
    )
  }

  renderLogin = () => {

    const {
      gameid, 
      serverid: gameserverid,
      viprovid,
      dollar,
      maxDollar,
      minDollar,
      tab,
      character,
      descriptoin,
      tradetime,
    } = this.state;

    
    const { gameListMap } = this.props;
    
    const sellerMap = this.props.sellerMap[`${viprovid},${gameid},${gameserverid}`];
    const game = gameListMap[gameid];
    const gamename = sellerMap ? sellerMap.gamename : '';
    
    if(!game || !sellerMap) return this.renderLoading(); 
    
    const path = {
      preState: 'game',
      preTitle: '出售區遊戲列表',
      title: gamename.trim(),
    };

    const gameImgSrc = `${GLOBAL.imgSrcRootURL}/gameimgs/${game.gameid}/${game.idximg}`;

    const {
      nickname = '',
      vitemdollar = 0,
      ntdollar = 0,
      inventory = 0,
      commission,
      notice,
    } = sellerMap;

    const proportion = vitemdollar / ntdollar;
    const commissionPrice = commission ?
      Math.round((this.state.dollar / 100) * commission) : 0;

    let conversionPrice = (this.state.dollar * proportion ) - (commissionPrice * proportion);
    conversionPrice = Math.round(conversionPrice);

    const data = {
      name: nickname.trim(),
      money: `${ntdollar} : ${vitemdollar}`,
      num: inventory,
      vPrice: conversionPrice || 0,
      commissionPrice,
      dollar: dollar,
      maxDollar,
      minDollar,
      proportion,
      character,
      descriptoin,
      tradetime,
    };

    const bonus = this.state.dollar ? Math.floor(this.state.dollar / 100) : 0;

    return (
      <React.Fragment>
        <BreadCrumbs path={path} />
        <Container>
          <GameBlock title={gamename.trim()} img={gameImgSrc} />
          <Main>
            <TradeDetail
              data={data}
              handleCharacterInput={this.handleCharacterInput}
              handleDescriptoinInput={this.handleDescriptoinInput}
              handleTradetimeInput={this.handleTradetimeInput}
              addTradeMoney={this.addTradeMoney}
              minusTradeMoney={this.minusTradeMoney}
              handleDollarChange={this.handleDollarChange}
              error={this.state.error_dollarInput}
              submit={this.submit}
              disableSubmit={!this.state.isOpen}
            />
            <NavContainer>
              <NavList gridNum={2} >
                <NavItem bold isActive={tab === TABS.NOTICE} onClick={this.changeTabToNotice}>
                    <NavItemTouch>商品詳情</NavItemTouch>
                </NavItem>
                <NavItem bold isActive={tab === TABS.MESSAGE} onClick={this.changeTabToMessage}>
                    <NavItemTouch>留言板</NavItemTouch>
                </NavItem>
              </NavList>
            </NavContainer>
            {
              tab === TABS.NOTICE ?
              ( <ProductDetail commission={commission} bonus={bonus} notice={notice.trim()} /> )
              :
              ( <CommentBoard /> )
            }
          </Main>
        </Container>
      </React.Fragment>
    );
  }

  renderNoLogin = () => (
    <GlobalStyle.BasicBlock>
      <GlobalStyle.ErrorContainer>
        <GlobalStyle.ErrorContainerTitle>您尚未登入</GlobalStyle.ErrorContainerTitle>
        <GlobalStyle.ErrorContainerDesription>您尚未登入，請登入後再重新操作一次。</GlobalStyle.ErrorContainerDesription>
      </GlobalStyle.ErrorContainer>
    </GlobalStyle.BasicBlock>
  )

  renderLoading = () => (
    <GlobalStyle.LoadingContainer>
      <GlobalStyle.Spin />
    </GlobalStyle.LoadingContainer>
  )

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    haslogin: state.member.haslogin,
    sellerMap: state.vitem.sellerMap,
    isloading: state.vitem.isloading,
    gameListMap: state.game.gameListMap,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    vitemActions: bindActionCreators(actionCreators.vitemActionCreators, dispatch),
    gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(SaleDetailView);

